module.exports = "<div class=\"row\">\r\n  <div class=\"column\">\r\n    <h1>Privacy policy</h1>\r\n    <p>Content here...</p>\r\n  </div>\r\n</div>"